export default {
  columns: [
    {
      caption: 'CONTRACT',
      dataField: 'contractName',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'BDORDER',
      dataField: 'bdOrder',
      dataType: 'number',
      area: 'column',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'BDNAME',
      dataField: 'bdName',
      dataType: '',
      area: 'column',
      expanded: true,
    }, {
      caption: 'AREF',
      dataField: 'aref',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'PATH',
      dataField: 'pathName',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'METERID',
      dataField: 'meterId',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'PREMISEID',
      dataField: 'premiseId',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'CHANNEL',
      dataField: 'channel',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'TRADEID',
      dataField: 'tradeId',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'SCHEDULEID',
      dataField: 'scheduleId',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'PRICENODE',
      dataField: 'priceNode',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'RESOURCE',
      dataField: 'resource',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'TAGID',
      dataField: 'tagId',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'CP_NAME',
      dataField: 'cpName',
      dataType: '',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'TRADINGDATE',
      dataField: 'tradingDate',
      dataType: 'date',
      format: 'MM/dd/yyyy',
      area: 'row',
      expanded: true,
    }, {
      caption: 'TRADINGHOUR',
      dataField: 'tradingHour',
      dataType: 'number',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'TRADING INTERVAL',
      dataField: 'tradingInterval',
      dataType: 'number',
      area: 'filter',
      expanded: true,
    }, {
      caption: 'CompareType',
      dataField: 'compareType',
      dataType: 'string',
      area: 'row',
      expanded: true,
    }, {
      caption: 'VAL',
      dataField: 'intValue',
      dataType: 'number',
      area: 'data',
      summaryType: 'sum',
      expanded: true,
      format: '#.######',
    }, {
      caption: 'Attribute1',
      dataField: 'attribute1',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute2',
      dataField: 'attribute2',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute3',
      dataField: 'attribute3',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute4',
      dataField: 'attribute4',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute5',
      dataField: 'attribute5',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute6',
      dataField: 'attribute6',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute7',
      dataField: 'attribute7',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute8',
      dataField: 'attribute8',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute9',
      dataField: 'attribute9',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute10',
      dataField: 'attribute10',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute11',
      dataField: 'attribute11',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute12',
      dataField: 'attribute12',
      area: 'filter',
      expanded: true,
      visible: true,
    }, {
      caption: 'Attribute13',
      dataField: 'attribute13',
      area: 'filter',
      expanded: true,
      visible: true,
    },
  ],
};